export default __webpack_public_path__ + "static-bigflip/media/ilus-maintenance.16bce462.png";